module.exports = __webpack_public_path__ + "static/media/PORTADA.d2863e8f.jpg";